import { Item } from '@/models/item';

const items: Array<Item> = [];

items.push(new Item({
  name: 'オーラツー ミー ステインクリアペースト',
  limitedMCC: false,
}));

// items.push(new Item({
//   name: 'オーラツーミー ステインクリアペースト（ナチュラルミント）',
//   limitedMCC: false,
// }));

// items.push(new Item({
//   name: 'オーラツーミー ステインクリアペースト（ピーチリーフミント）',
//   limitedMCC: false,
// }));

// items.push(new Item({
//   name: 'オーラツーミー ステインクリアペースト（フローラルホワイトティーミント）',
//   limitedMCC: false,
// }));

items.push(new Item({
  name: 'オーラツー プレミアム ステインクリアペースト',
  limitedMCC: false,
}));

// items.push(new Item({
//   name: 'オーラツー プレミアム ステインクリア ペースト（プレミアムミント）',
//   limitedMCC: false,
// }));

// items.push(new Item({
//   name: 'オーラツー プレミアム ステインクリア ペースト（アロマティックミント）',
//   limitedMCC: false,
// }));

// items.push(new Item({
//   name: 'オーラツー プレミアム ステインクリア ペースト（シャイニーシトラスミント）',
//   limitedMCC: false,
// }));

items.push(new Item({
  name: 'オーラツー プレミアム マウスウォッシュ ダブルクレンジング',
  limitedMCC: false,
}));

// items.push(new Item({
//   name: 'オーラツー プレミアム マウスウォッシュ ダブルクレンジング（リフレッシュ）',
//   limitedMCC: false,
// }));

// items.push(new Item({
//   name: 'オーラツー プレミアム マウスウォッシュ ダブルクレンジング（フローラル）',
//   limitedMCC: false,
// }));

items.push(new Item({
  name: 'オーラツー プレミアム クレンジングペースト',
  limitedMCC: true,
}));

// items.push(new Item({
//   name: 'オーラツー プレミアム クレンジングペースト（プレミアムミント）',
//   limitedMCC: true,
// }));

// items.push(new Item({
//   name: 'オーラツー プレミアム クレンジングペースト（アロマティックミント）',
//   limitedMCC: true,
// }));

export default items;
